<div
  class="category-details flex-auto col-span-2 justify-center mr-8 border border-outline rounded-3 p-8 {{
    isLoading() ? 'opacity-50 pointer-events-none' : ''
  }}"
>
  <cac-form-builder [options]="form" class="mt-5" />
  <cac-button class="w-fit" (onClick)="onSave()">Save</cac-button>
</div>
